import { CustomerSecurityComplianceDTO } from "../DTO/customerSecurityComplianceDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateCustomerSecurityComplianceRequest extends BasicRequest{
    
    public customerSecurityCompliance! : CustomerSecurityComplianceDTO;

    constructor(){
        super();
    }
}